import manageJss from "@microsoft/fast-jss-manager-react";
import { ActionTriggerStyles, } from "@microsoft/fast-components-styles-msft";
import MSFTActionTrigger, { ActionTriggerAppearance, } from "./action-trigger";
import actionTriggerSchema from "./action-trigger.schema";
import actionTriggerSchema2 from "./action-trigger.schema.2";
/*
 * The type returned by manageJss type is very complicated so we'll let the
 * compiler infer the type instead of re-declaring just for the package export
 */
const ActionTrigger = manageJss(ActionTriggerStyles)(MSFTActionTrigger);
export { ActionTrigger, ActionTriggerAppearance, actionTriggerSchema, actionTriggerSchema2, };
